export const RESULT_IMAGE_DIMENSIONS = 48;
